import React from 'react'

class Footer extends React.Component {
  render() {
    return (
      <div id="footer">
        <div className="inner">
          <ul className="icons">
            <li>
              <a href="/" className="icon fa-twitter">
                <span className="label">Twitter</span>
              </a>
            </li>
            <li>
              <a href="/#four" className="icon fa-envelope-o">
                <span className="label">Email</span>
              </a>
            </li>
          </ul>
          <ul className="copyright">
            <li>&copy;2026 Albert Steijger Allround Timmerwerk</li>
            <li>Mobiel 06-36309684</li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Footer
